import { render } from "./album.vue?vue&type=template&id=639e9747&scoped=true"
import script from "./album.vue?vue&type=script&lang=js"
export * from "./album.vue?vue&type=script&lang=js"

import "./album.vue?vue&type=style&index=0&id=639e9747&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639e9747"]])

export default __exports__